import { render } from "./ViewAiPanel.vue?vue&type=template&id=3ad6d402"
import script from "./ViewAiPanel.vue?vue&type=script&lang=js"
export * from "./ViewAiPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__